module.exports = __webpack_public_path__ + "static/img/son2_active.0c865de3.png";